import { render } from "./NewsFlash.vue?vue&type=template&id=4bd49efc&scoped=true"
import script from "./NewsFlash.vue?vue&type=script&lang=ts"
export * from "./NewsFlash.vue?vue&type=script&lang=ts"

import "./NewsFlash.vue?vue&type=style&index=0&id=4bd49efc&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4bd49efc"

export default script